import GraphRanges from "@/mixins/GraphRanges";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

@Component({})
export default class GenericRiskAndGraph extends mixins(GraphRanges) {
  @Getter("segmentRisk", patientNamespace)
  segmentRisk!: any;

  @Getter("graph", patientNamespace)
  graph!: any;

  @Getter("name", navigationNamespace)
  name!: string;

  get title() {
    if (
      this.popupDescription &&
      this.popupDescription.popupConfig &&
      this.popupDescription.popupConfig.title
    ) {
      return this.popupDescription.popupConfig.title;
    } else {
      return "Unexpected";
    }
  }

  get charts(): MultiChartConfig[] {
    const chartList: any[] = [];
    if (
      this.popupDescription.popupConfig &&
      this.popupDescription.popupConfig.graphs
    ) {
      this.popupDescription.popupConfig.graphs.forEach(g => {
        const { source, ...props } = g;
        chartList.push({
          data: this.graph(g.source),
          ...props
        });
      });
    }
    return chartList;
  }
}
